import "client-only";

import {
  BacktestGenerationResultSchema,
  FunctionDefinitionsSchema,
  VariableDefinitionsSchema,
  type BacktestGenerationResult,
  type FunctionDefinition,
  type GenerateBacktestRequest,
  type VariableDefinition,
} from "@/contracts/backtests";
import { client } from "@/lib/platform/client";

async function fetchVariableDefinitions(): Promise<VariableDefinition[]> {
  return client.get("/api/backtests/variables/definitions", {
    expect: VariableDefinitionsSchema,
  });
}

async function fetchFnDefinitions(): Promise<FunctionDefinition[]> {
  return client.get("/api/backtests/functions/definitions", {
    expect: FunctionDefinitionsSchema,
  });
}

async function fetchVariableValue(variableName: string, ticker: string, bar: number) {
  const params = new URLSearchParams({ ticker, bar: bar.toString() });
  return client.get(
    `/api/backtests/variables/${encodeURIComponent(variableName)}/value?${params.toString()}`,
  );
}

async function generate(request: GenerateBacktestRequest): Promise<BacktestGenerationResult> {
  return client.post(
    "/api/backtests/generate",
    request,
    { expect: BacktestGenerationResultSchema },
  );
}

export const backtests = {
  fetchFnDefinitions,
  fetchVariableDefinitions,
  fetchVariableValue,
  generate,
};
